import { actionTypes } from '@/core/constants'
import DocumentosUrlBuilder from '@/core/utils/factory/documentos/DocumentosUrlBuilder'
import DocumentoProcessoDigitalApiClient from '@/core/apiclient/documentos/processo-digital/DocumentoProcessoDigitalApiClient'

function getApiClient(obj) {
	const urlBuilder = new DocumentosUrlBuilder(obj.tipo)
	return new DocumentoProcessoDigitalApiClient(urlBuilder)
}

export default {
	async [actionTypes.DOCUMENTOS.PROCESSO_DIGITAL.ASSINAR_ELETRONICAMENTE](context, objt) {
		let apiClient = getApiClient(objt)
		let { data } = await apiClient.assinarDocumentoEletronicamente(objt.documento)
		return data
	},
	async [actionTypes.DOCUMENTOS.PROCESSO_DIGITAL.ASSINAR_DIGITALMENTE](context, objt) {
		let apiClient = getApiClient(objt)
		let { data } = await apiClient.assinarDocumentoDigitalmente(objt.documento)
		return data
	},
	async [actionTypes.DOCUMENTOS.PROCESSO_DIGITAL.VALIDAR_DOCUMENTO_ASSINADO](context, objt) {
		let apiClient = getApiClient(objt)
		let { data } = await apiClient.validarDocumentoAssinado(objt.documento)
		return data
	},
	async [actionTypes.DOCUMENTOS.PROCESSO_DIGITAL.JUNTAR_LOTE_DOCUMENTOS](context, objt) {
		let apiClient = getApiClient(objt)
		const { data } = await apiClient.juntarLoteDocumentosProcessoDigital(objt)
		return data
	},
	async [actionTypes.DOCUMENTOS.PROCESSO_DIGITAL.BUSCAR_DOCUMENTO_POR_ID](context, objt) {
		let apiClient = getApiClient(objt)
		const { data } = await apiClient.buscarDocumentoPorId(objt.documento)
		return data
	},
}
